'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _functional = require('../utils/functional');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
  container: '[data-filters-container]',
  block: '[data-filters-block]',
  title: '[data-filters-title]',
  items: '[data-filters-items]',
  individualItems: '[data-filters-item]',
  link: '[data-filters-link]',
  allItem: '[data-filters-item-all]'
};

var DrawerCollectionFilters = function () {
  function DrawerCollectionFilters(el) {
    (0, _classCallCheck3.default)(this, DrawerCollectionFilters);

    this.context = { context: el };

    this.items = (0, _functional.getElements)(selectors.items, this.context);

    this.setItemsHeights();
    this.initialiseBlocks();

    el.addEventListener('click', function (_ref) {
      var target = _ref.target;

      var targetIsTitle = target.closest(selectors.title);
      var targetsParent = target.closest(selectors.block);

      if (targetIsTitle) {
        var isCurrentlyOpen = targetsParent.getAttribute('aria-expanded') === 'true';
        var items = (0, _functional.getElement)(selectors.items, { context: targetsParent });

        if (isCurrentlyOpen) {
          (0, _utils.slideUp)(items, items.dataset.height);
          targetsParent.setAttribute('aria-expanded', 'false');
        } else {
          (0, _utils.slideDown)(items, items.dataset.height);
          targetsParent.setAttribute('aria-expanded', 'true');
        }
      }
    });
  }

  (0, _createClass3.default)(DrawerCollectionFilters, [{
    key: 'setItemsHeights',
    value: function setItemsHeights() {
      this.items.forEach(function (item) {
        var existingHeight = item.style.height || '';

        item.style.height = '';
        item.dataset.height = item.offsetHeight;
        item.style.height = existingHeight;
      });
    }
  }, {
    key: 'initialiseBlocks',
    value: function initialiseBlocks() {
      this.items.forEach(function (item) {
        var block = item.closest(selectors.block);
        if (block.getAttribute('aria-expanded') === 'false') {
          (0, _utils.slideUp)(item, item.dataset.height);
        }
      });
    }
  }]);
  return DrawerCollectionFilters;
}();

exports.default = DrawerCollectionFilters;